import { useCallback, useState } from "react";
import { isMobileApp } from "utilities/src/platform";
export const DEFAULT_MIN_WIDTH = isMobileApp ? 40 : 24;
export const DEFAULT_MIN_HEIGHT = DEFAULT_MIN_WIDTH;
export function useAutoDimensions({
  onLayout: onLayoutParam,
  width: widthParam,
  height: heightParam,
  shouldConsiderMinimumDimensions = false
}) {
  const [dimensions, setDimensions] = useState({
    width: void 0,
    height: void 0
  });
  const onLayout = useCallback(
    (event) => {
      onLayoutParam?.(event);
      const { width: layoutWidth, height: layoutHeight } = event.nativeEvent.layout;
      const width = Math.round(layoutWidth);
      const height = Math.round(layoutHeight);
      if (!shouldConsiderMinimumDimensions) {
        return;
      }
      const maybeNewWidth = width <= DEFAULT_MIN_WIDTH ? DEFAULT_MIN_WIDTH : void 0;
      const maybeNewHeight = height <= DEFAULT_MIN_HEIGHT ? DEFAULT_MIN_HEIGHT : void 0;
      setDimensions((prevDimensions) => {
        const shouldUpdateWidth = prevDimensions.width !== maybeNewWidth;
        const shouldUpdateHeight = prevDimensions.height !== maybeNewHeight;
        if (shouldUpdateWidth || shouldUpdateHeight) {
          return {
            width: maybeNewWidth,
            height: maybeNewHeight
          };
        }
        return prevDimensions;
      });
    },
    [onLayoutParam, shouldConsiderMinimumDimensions]
  );
  const widthToReturn = shouldConsiderMinimumDimensions ? dimensions.width : widthParam;
  const heightToReturn = shouldConsiderMinimumDimensions ? dimensions.height : heightParam;
  return { onLayout, width: widthToReturn, height: heightToReturn };
}
